import React from 'react';
import styled from 'styled-components';

export const SellerNewStore = () => <Badge>Loja Nova!</Badge>;

const Badge = styled.span`
  height: 18px;
  background-color: #c7e5fc;
  color: #003f76;
  padding: 0 12px 0 16px;
  font-size: 10px;
  transform: translateX(-16px);
  margin-bottom: 8px;
  display: inline-block;
  line-height: 18px;
  position: relative;

  &::before,
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    left: 100%;
  }

  &::before {
    border-width: 9px 9px 0 0;
    border-color: #c7e5fc transparent transparent transparent;
    top: 0;
  }

  &::after {
    border-width: 9px 0 0 9px;
    border-color: transparent transparent transparent #c7e5fc;
    bottom: 0;
  }
`;
